import styled from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { INNER_CARD_BORDER_RADIUS, INNER_CARD_PADDING } from 'developer-docs-shared-components/config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ParamWrapper = styled.div.withConfig({
  displayName: "EndpointParameters__ParamWrapper",
  componentId: "sc-1cs2g94-0"
})(["padding-top:", "px;border:1px solid ", ";border-radius:", "px;"], INNER_CARD_PADDING, ({
  theme
}) => theme.color['do-not-use-great-white'], INNER_CARD_BORDER_RADIUS);

// TODO: Implement empty state
const EndpointParameters = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(ParamWrapper, {
    className: "params",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.params.header.parameters"
      })
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      children: /*#__PURE__*/_jsx("div", {
        className: "params-block",
        children: children || /*#__PURE__*/_jsx(Text, {
          fontStyle: "italic",
          paddingBlockEnd: "600",
          paddingInlineStart: "600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.noParams"
          })
        })
      })
    })]
  });
};
export default EndpointParameters;